import { render, staticRenderFns } from "./1to50.vue?vue&type=template&id=c39d8f92&scoped=true"
import script from "./1to50.vue?vue&type=script&lang=js"
export * from "./1to50.vue?vue&type=script&lang=js"
import style0 from "./1to50.vue?vue&type=style&index=0&id=c39d8f92&prod&lang=css&scoped=true"
import style1 from "./1to50.vue?vue&type=style&index=1&id=c39d8f92&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39d8f92",
  null
  
)

export default component.exports